import { Component, Input, OnInit } from '@angular/core';
import { ValidationSummary } from '../../models/validation-summary';

@Component({
    selector: 'validation-message',
    templateUrl: './validation-message.component.html',
    styleUrls: ['./validation-message.component.css'],
    standalone: false
})
export class ValidationMessageComponent implements OnInit {
    private _validationSummary: ValidationSummary = {};
    @Input() set validationSummary(value: ValidationSummary) {
        this._validationSummary = value || { errors: [] };
    }

    get validationSummary(): ValidationSummary {
        return this._validationSummary;
    }
    constructor() { }

    ngOnInit(): void {
    }

}
